module.exports = __webpack_public_path__ + "img/logonew.57b8afc5.jpg";